<template>
    <base-nav class="navbar-top navbar-dark"
              id="navbar-main"
              :show-toggle-button="false"
              expand>
        <form class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
            <div class="form-group mb-0"></div>
        </form>
        <ul class="navbar-nav align-items-center d-none d-md-flex">
            <li class="nav-item dropdown">
                <base-dropdown class="nav-link pr-0">
                    <div class="media align-items-center" slot="title">
                      <div
                        class="media-body ml-2 d-none d-lg-block"
                        v-if="basicProfile && basicProfile.first_name"
                      >
                        <i class="ni ni-bell-55"></i>
                        <span class="mb-0 text-sm  font-weight-bold text-capitalize" @click="getNotifications">
                          Notifications
                          <badge type="white" v-if="notifications.total > 0">
                            {{ notifications.total }}
                          </badge>&nbsp;
                        </span>
                        <i class="fa fa-caret-down" aria-hidden="true"></i>
                      </div>
                    </div>

                    <template>
                        <div
                          v-if="displayNav(this.$route.name) && notifications && notifications.records
                                && notifications.records.length > 0"
                        >
                          <router-link
                            :to="'/notifications/'+notification.id"
                            class="dropdown-item"
                            v-for="notification in notifications.records"
                            :key="notification.id"
                          >
                            <i class="fa fa-angle-right"></i>
                            <span
                              :class="'notification-size ' +
                                ((notification.status == 'unread') ? 'font-weight-bold' : '')"
                            >
                              {{ truncate(notification.subject) }}
                            </span>
                          </router-link>
                        </div>
                        <div class="dropdown-divider"></div>
                        <router-link to="/notifications" class="dropdown-item">
                            <i class="ni ni-sound-wave"></i>
                            <span>View All</span>
                        </router-link>
                    </template>
                </base-dropdown>
            </li>
        </ul>
        <ul class="navbar-nav align-items-center d-none d-md-flex">
            <li class="nav-item dropdown">
                <base-dropdown class="nav-link pr-0">
                    <div class="media align-items-center" slot="title">
                      <span class="avatar avatar-sm rounded-circle">
                        <img
                            :alt="fullname"
                            :src="userPhotoUrl ? userPhotoUrl : blankImageUrl"
                            @error="replaceByDefault"
                            class="image-size"
                        >
                      </span>
                      <div
                        class="media-body ml-2 d-none d-lg-block"
                        v-if="fullname"
                      >
                        <span class="mb-0 text-sm  font-weight-bold text-capitalize">
                          {{ fullname }}
                        </span>
                        <i class="fa fa-caret-down" aria-hidden="true"></i>
                      </div>
                    </div>

                    <template>
                        <div class=" dropdown-header noti-title">
                            <h6 class="text-overflow m-0 text-capitalize" v-if="basicProfile.first_name">
                              Welcome, {{ basicProfile.first_name.toLowerCase() }}
                            </h6>
                        </div>

                        <div v-if="displayNav(this.$route.name)">
                          <router-link to="/profile"
                            class="dropdown-item"
                          >
                              <i class="ni ni-single-02"></i>
                              <span>My Account</span>
                          </router-link>
                          <router-link to="/change-password"
                            class="dropdown-item"
                          >
                              <i class="ni ni-settings-gear-65"></i>
                              <span>Change Password</span>
                          </router-link>
                          <router-link to="/notifications"
                            class="dropdown-item"
                          >
                              <i class="ni ni-bell-55"></i>
                              <span>Notifications</span>
                          </router-link>

                          <a href="/user-guide.pdf" target="_blank" class="dropdown-item">
                            <i class="ni ni-books"></i> User Guide
                          </a>
                        </div>

                        <div class="dropdown-divider"></div>
                        <router-link to="/logout" class="dropdown-item">
                            <i class="ni ni-user-run"></i>
                            <span>Logout</span>
                        </router-link>
                    </template>
                </base-dropdown>
            </li>
        </ul>
    </base-nav>
</template>
<script>
  // get user's details from store
  import { mapGetters, mapActions } from 'vuex';

  export default {
    data() {
      return {
        activeNotifications: false,
        showMenu: false,
        searchQuery: ''
      };
    },
    computed: {
      ...mapGetters(['basicProfile', 'fullname', 'blankImageUrl', 'notifications', 'docPhoto']),
      userPhotoUrl() {
        return this.docPhoto ? this.docPhoto.image : null;
      }
    },
    methods: {
      getNotifications() {
        return this.getUserNotifications(5);
      },
      truncate: function (text) {
        if (text.length > 30) {
          return text.substring(0, 30) + '...'
        } else {
          return text
        }
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
      toggleMenu() {
        this.showMenu = !this.showMenu;
      },
      ...mapActions(['getUserNotifications']),
      displayNav(value) {
        let data = ['New Account Purchase Insurance', 'Update Profile', 'New Account'];// eslint-disable-next-line
        return ($.inArray(value, data)) < 0;
      },
      replaceByDefault(e) {
        return e.target.src = this.blankImageUrl;
      }
    }
  };
</script>

<style scoped>
  .image-size {
    width: 40px;
    height: 40px;
  }
  .notification-size {
    font-size: 12px;
  }
</style>
